<template>
  <div>
    <h2>
      <slot></slot>
    </h2>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
  watch: {},
  methods: {},
  components: {},
};
</script>

<style lang="less" scoped>
h2 {
  font-size: 0.28rem;
  font-weight: 700;
  text-align: center;
  padding-top: 0.8rem;
  position: relative;
  color: #000;
  font-family: "Noto Sans SC";
}
h2::after {
  content: "";
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  right: 0;
  bottom: -0.15rem;
  width: 1.5em;
  height: 2px;
  border-bottom: 2px solid #000;
  box-sizing: border-box;
}
@media only screen and (max-width: 766px) {
  h2 {
    padding-top: 0.38rem;
    font-size: 0.36rem;
  }
}
</style>
